import { singleton } from 'tsyringe';
import { Subject } from 'rxjs';
import { Action } from 'deox/dist/create-action';

@singleton()
export class EpStore{
  actions$ = new Subject();

  dispatch(action: Action<string, any>){
    this.actions$.next(action);
  }
}
